import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id BAD1F323-E74E-4E04-A1F6-4CCC7CAC2E34
 * name drag-vertical-variant
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/drag-vertical-variant.svg
 * tags
 */
export const DragVerticalVariantIcon = createSvgIcon(<><path d="M11 21H9V3H11V21M15 3H13V21H15V3Z" /></>, 'DragVerticalVariantIcon');
export default DragVerticalVariantIcon